module.exports = __webpack_public_path__ + "static/media/tool_logo_qualys.8f7b2a7f.png";